import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import NFt3 from "assets/img/nfts/Nft3.png";
import tableDataTopCreators from "views/admin/tickets/variables/tableDataTopCreators.json";
import { tableColumnsTopCreators } from "views/admin/tickets/variables/tableColumnsTopCreators";
import HistoryCard from "./components/HistoryCard";
import UserStatusTable from "./components/UserStatusTable";
import NftCard from "components/card/NftCard";
import TICKET_STATUSES from "constants/constants";
import { fetchData } from "../../../services/ApiFetching";

const Ticket = () => {
  const location = useLocation();
  const [tickets, setTickets] = useState([]);
  const [agents, setAgents] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const userId = localStorage.getItem("id")
  const role = localStorage.getItem("role")

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const tickets = await fetchData("tickets");
        setTickets(tickets)
        const agentData = await fetchData("users");
        const agentNames = agentData.filter(user => user.role === "agents").map(user => user.username);
        setAgents(agentNames);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error.message || 'Failed to load tickets.');
      }
    };
    fetchAgents();
  }, [location]);

  const filteredTickets = selectedStatus === "all"
    ? tickets
    : tickets.filter(ticket => ticket.status === selectedStatus);

  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <div className="mt-3 grid h-full grid-cols-1 gap-5 xl:grid-cols-2 2xl:grid-cols-3">
        <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">
          {/* NFt Header */}
          <div className="mb-4 flex flex-col justify-end px-4 md:flex-row md:items-center">
            <ul className="mt-4 flex items-center justify-between md:mt-0 md:justify-center md:!gap-5 2xl:!gap-12">
              {[
                { value: "all", label: "All" },
                ...TICKET_STATUSES
              ].map((status) => (
                <li key={status.value}>
                  <a
                    href="#"
                    className={`text-base font-medium ${selectedStatus === status.value
                      ? "text-base font-medium text-brand-500 hover:text-brand-500 dark:text-white underline"
                      : "text-base font-medium text-brand-500 hover:text-brand-500 dark:text-white"
                      }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedStatus(status.value);
                    }}
                  >
                    {status.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* NFTs trending card */}
          <div className="z-20 grid grid-cols-1 gap-5 md:grid-cols-3">
            {filteredTickets && filteredTickets.length > 0 ? (
              (role === "agent"
                ? filteredTickets.filter((ticket) => ticket.assigned_to === Number(userId))
                : filteredTickets
              ).map((ticket) => (
                <NftCard
                  key={ticket.id}
                  id={ticket.id}
                  title={ticket.subject || "Ticket Title"}
                  assigned_to={ticket.assigned_to_user || "Unknown User"}
                  status={ticket.status || "Status"}
                  image={ticket.image || NFt3}
                  created_at={ticket.created_at || "Date Not Available"}
                  agents={agents}
                  tickets={tickets}
                />
              ))
            ) : (
              <div className="col-span-full text-center text-gray-500">
                No tickets available for this status
              </div>
            )}
          </div>

        </div>

        {/* right side section */}
        <div className="col-span-1 h-full w-full rounded-xl 2xl:col-span-1">
          <UserStatusTable
            extra="mb-5"
            tableData={tableDataTopCreators}
            columnsData={tableColumnsTopCreators}
          />
          <HistoryCard tickets={tickets} />
        </div>
      </div>
    </>
  );
};

export default Ticket;
